import { FormTokenField } from '@wordpress/components';

const MultiSelectControl = ({ field, value, onChange }) => {
    // Ensure options is always an array
    const options = Array.isArray(field?.options) ? field.options : [];
    const suggestions = options.map((opt) => opt.label);

    // Ensure value is always an array
    const selectedLabels = Array.isArray(value)
        ? value.map((val) => options.find((opt) => opt.value === val)?.label).filter(Boolean)
        : [];

    return (
        <FormTokenField
            label={field?.label || ''}
            value={selectedLabels}
            suggestions={suggestions}
            onChange={(newLabels) => {
                const newValues = newLabels
                    .map((label) => options.find((opt) => opt.label === label)?.value)
                    .filter(Boolean);
                onChange(newValues);
            }}
        />
    );
};

export default MultiSelectControl;
